// Configuration file for API endpoints
// Change these values when deploying to production

const isDevelopment = process.env.NODE_ENV === 'development';

// Backend API URL
// Development: http://localhost:8000
// Production: https://carsambacigkofte.com/backend
export const API_BASE_URL = isDevelopment 
  ? 'http://localhost:8000' 
  : 'https://carsambacigkofte.com/backend';

// Full API endpoint
export const API_URL = `${API_BASE_URL}/api.php`;

// Image base URL for uploaded images
export const IMAGE_BASE_URL = isDevelopment
  ? 'http://localhost:8000'
  : 'https://carsambacigkofte.com/backend';

// Frontend URL for CORS (used in backend)
export const FRONTEND_URL = isDevelopment
  ? 'http://localhost:3000'
  : 'https://carsambacigkofte.com';

// Contact Information
export const CONTACT_INFO = {
  phone: '+90 555 019 71 34',
  phoneRaw: '05550197134', // For tel: links (without +90)
  whatsapp: '905550197134', // WhatsApp number (with country code, no +)
  email: 'info@resumecigkofte.com',
  emailOrder: 'siparis@resumecigkofte.com',
  address: {
    line1: 'Kirazlı Çay Mah, Değirmen Başı Cad.',
    line2: 'No:67/A-C A Blok Şeker Evleri'
  },
  workingHours: '10:00-04:00'
};

// Social Media Links
export const SOCIAL_MEDIA = {
  facebook: 'https://facebook.com/yourpage', // TODO: Update with your Facebook page
  instagram: 'https://instagram.com/yourpage', // TODO: Update with your Instagram
  twitter: 'https://twitter.com/yourpage' // TODO: Update with your Twitter
};

// Google Maps Embed URL
// Samsun Çarşamba Resume Çiğköfte konumu
// Koordinatlar: 41.1934265, 36.7207593
// Place ID: 0x4088077c859e9645:0xd6ae6a8d7538a9a3
export const GOOGLE_MAPS_EMBED = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.5!2d36.7207593!3d41.1934265!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4088077c859e9645%3A0xd6ae6a8d7538a9a3!2sSamsun%20%C3%87ar%C5%9Famba%20Resume%20%C3%87i%C4%9Fk%C3%B6fte!5e0!3m2!1str!2str!4v1700000000000!5m2!1str!2str';

